import { render, staticRenderFns } from "./AuthenticationPage.vue?vue&type=template&id=33f8a7b6&scoped=true"
import script from "./AuthenticationPage.vue?vue&type=script&lang=js"
export * from "./AuthenticationPage.vue?vue&type=script&lang=js"
import style0 from "./AuthenticationPage.vue?vue&type=style&index=0&id=33f8a7b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f8a7b6",
  null
  
)

export default component.exports